import Icon from "~/components/ui/Icon";

export interface Props {
  phone: string;
  message?: string;
}

function WhatsApp({ phone, message }: Props) {
  if (!phone) {
    return null;
  }

  const textMessage = message ?? "";

  return (
    <a
      className="group fixed bottom-[87px] right-3 z-40 inline-flex h-7 w-7 items-center justify-center gap-2 overflow-hidden rounded bg-[#1A1A1A] text-white transition-all duration-300 hover:w-26 md:h-[38px] md:w-[38px] md:hover:w-47"
      href={`https://api.whatsapp.com/send/?phone=${phone}&text=${textMessage}`}
      target="_blank"
      aria-label="Chat on WhatsApp"
    >
      <Icon
        id="WhatsApp"
        size={16}
        className="shrink-0 text-white md:h-5 md:w-5"
      />
      <span className="hidden whitespace-nowrap font-['Poppins'] text-xs font-normal uppercase leading-4 text-white group-hover:inline">
        Compre pelo whats
      </span>
    </a>
  );
}

export default WhatsApp;
